import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

// Get product listing
export const productListingSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getProductListing: builder.query({
      // Accept an object containing limit and page
      query: ({ limit = 10, page = 1 }) => ({
        url: `supplier-products?limit=${limit}&page=${page}`,
        method: "GET",
      }),
      providesTags: [tagsTypes.GET_PRODUCT_LIST],
    }),

    getProductDetailPreview: builder.query({
      // Accept an object containing limit and page
      query: (id) => ({
        url: `product-detail-preview/${id}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetProductListingQuery, useGetProductDetailPreviewQuery } =
  productListingSlice;
